import type { ReactNode } from 'react';

export interface TourStep {
    id: string;
    targetSelector: string; // CSS selector for the target element
    title: string;
    description: string;
    position?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
    icon?: ReactNode;
}

export interface TourConfig {
    id: string;
    name: string;
    steps: TourStep[];
}

// Parent onboarding tour steps
export const parentTourSteps: TourStep[] = [
    {
        id: 'welcome',
        targetSelector: '[data-tour="profile-menu"]',
        title: 'Welcome to ADJJA Academy! 👋',
        description: 'Let\'s take a quick tour to help you get started managing your family\'s training.',
        position: 'left'
    },
    {
        id: 'schedule-tab',
        targetSelector: '[data-tour="schedule-tab"]',
        title: 'Class Schedule',
        description: 'Check when classes are available and enroll your kids in training sessions.',
        position: 'right'
    },
    {
        id: 'notifications',
        targetSelector: '[data-tour="notifications"]',
        title: 'Stay Updated',
        description: 'Get notified about class changes, achievements, and important announcements.',
        position: 'left'
    },
    {
        id: 'profile-menu',
        targetSelector: '[data-tour="profile-menu"]',
        title: 'Your Account',
        description: 'Update your account settings, manage payments, and access help resources. You can restart this tour anytime from here!',
        position: 'left'
    }
];

export const tourConfigs: Record<string, TourConfig> = {
    'parent-onboarding': {
        id: 'parent-onboarding',
        name: 'Parent Onboarding Tour',
        steps: parentTourSteps
    }
};
